<template>
  <div class="download2">
    <div class="header-img">
      <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/banner.png" alt />
    </div>
    <div class="toobar">
      <img align="Baseline" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/shouye.png" />&nbsp;&nbsp;&nbsp;1+X证书&nbsp;&nbsp;&nbsp;
      <img
        align="AbsMiddle"
        src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/sanjiao.png"
        alt
      />&nbsp;&nbsp;&nbsp;垃圾焚烧发电运行与维护仿真系统
    </div>
    <div class="middle">
      <div class="wenzi" style="margin: 0px auto;width: 1100px;">
        <div
          style="padding-top: 48px;margin-left: -10px;font-family: simhei;font-size: 60px;color: #e8e7e8;"
        >INTRODUCTION</div>
        <div
          style="font-family: simhei;font-size: 28px;color: #4b4b4b;margin-bottom: 48px;"
        >垃圾焚烧发电运行与维护仿真系统简介</div>
        <div style="font-size: 14px;color: #666666;">
          <p>本仿真系统机组按4炉2机配置,设四台600吨/天机械炉排焚烧炉、两台25MW凝汽式汽轮机和2台30MW发电机组，4台锅炉产生的蒸汽先引往一根蒸汽母管集中后，再由该母管引出 2 根蒸汽管接至汽轮机和各用汽处。</p>
          <p>锅炉由垃圾焚烧炉和余热锅炉两部分组成。垃圾焚烧炉炉排为L型倾斜多级往复式炉排，每台焚烧炉最大连续处理垃圾量为25t/h，余热锅炉是单锅筒自然循环水管锅炉，卧式、 室内布置、微负压运行，落地抗震结构的锅炉。余热锅炉设置在垃圾焚烧炉上方，以回收焚烧所产生的热量。</p>
          <p>汽轮机为N25-3.82/390型非再热、冲动式、冷凝式汽轮机。机组采用单汽缸结构和减速箱一起，安装在一个公共底盘上。汽轮机的额定转速为5500 r/min，具有三级回热抽汽，抽汽管道上设有液动逆止阀、安全阀和关断阀，以防止抽汽口有汽流倒流至汽机。与锅炉、发电机及其他辅助设备配套成一个成套供热发电设备。</p>
          <p>发电机为QFW30-4/10.5KV型汽轮发电机。单台汽轮发电机的额定功率为25MW，额定电压10KV，单台主变压器的额定容量为40MKVA。发电机额定转速为1500 r/min，频率为50Hz，采用封闭循环通风系统，并装有空气冷却器来冷却空气。发电机的励磁由无刷励磁装置供给。</p>
          <p>为了控制锅炉燃烧后的烟气尾气达标，还增加了烟气处理系统，该烟气处理系统工艺为SNCR+旋转喷雾脱酸塔+石灰浆制备及喷射系统+干粉喷射系统+活性炭喷射装置+高效袋式除尘器+选择性催化还原法（SCR）相结合的烟气净化工艺。</p>
          <p>另外，辅助系统也是垃圾焚烧发电仿真机的重要的组成部分，主要包括液压系统、风烟系统、燃气系统、空气预热器系统、压缩空气系统、输灰渣系统、飞灰处理系统、活性炭输送系统、石灰浆制备系统、烟气处理系统、垃圾给料系统、汽水系统、除臭系统等。</p>
        </div>
        <div style="display: flex;justify-content: space-between;margin-top: 50px;">
          <a href="http://39.106.224.133:83/wxApp/垃圾焚烧发电运行与维护仿真系统.zip">
            <img width="450px" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/anzhuangbao.png" />
          </a>
          <a href="http://39.106.224.133:83/wxApp/垃圾焚烧发电运行与维护仿真系统安装使用说明.zip">
            <img width="450px" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/shuomingshu.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.download2 {
  background: #eee;
}

.download2 img {
    display: inline-block;
}

.download2 .header-img {
  width: 100%;
  height: 237px;
}

.download2 .header-img img {
  width: 100%;
  height: 100%;
}

.download2 .middle {
  width: 100%;
  height: 680px;
  background: url(http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/dibeijing.png) no-repeat;
  background-size: 100% 100%;
}

.download2 .toobar {
  height: 90px;
  width: 1100px;
  margin: 0 auto;
  line-height: 90px;
  color: #929292;
}

.download2 .middle img:hover {
  cursor: pointer;
}

.download2 a {
  color: #fefefe;
  text-decoration: none;
}

.download2 a:hover {
  cursor: pointer;
}

.download2 li {
  width: 100px;
  height: 80px;
  color: #fefefe;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  display: list-item;
}

.download2 li:hover {
  background: #0a57f4;
}
</style>